import React, { memo, useState } from 'react'
import { Stack } from '@mui/material'
import { faLink } from '@fortawesome/pro-light-svg-icons'

import HeadingWithHelpText from '../shared/text/HeadingWithHelpText'
import DefaultText from '../shared/text/DefaultText'
import CustomButton from '../shared/buttons/CustomButton'
import { REFERRAL_EARNING } from '../../constants/app'
import LabelValue from '../shared/text/LabelValue'
import { copyToClipboard } from '../../util/app.helpers'
import { formatPts } from '../../util/numbers.helpers'

const ReferFriends = ({
  t,
  address,
  saleEnded,
  mainProfile: { friendsReferred, referPointsEarned }
}) => {
  const [copiedLink, setCopiedLink] = useState(false)
  const onCopyReferralLink = () => {
    copyToClipboard(`${window.location.href}?code=${address}`)
    setCopiedLink(true)
  }
  return (
    <Stack spacing={2}>
      <HeadingWithHelpText
        label={t('referral.referral-title')}
        helpText={t('referral.referral-help-text')}
      />
      <DefaultText
        label={t('referral.referral-desc', { value: REFERRAL_EARNING })}
        noMargin
      />
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        spacing={3}
        sx={{ alignItems: 'center' }}
      >
        <CustomButton
          icon={faLink}
          label={t('referral.copy-referral-link')}
          onClick={onCopyReferralLink}
          variant='outlined'
          color='white'
          disabled={!address || saleEnded}
        />
        <LabelValue
          label={t('referral.friends-referred')}
          value={friendsReferred}
          fontSize={1.125}
        />
        <LabelValue
          label={t('referral.points-earned')}
          value={formatPts(referPointsEarned)}
          fontSize={1.125}
        />
      </Stack>
      {copiedLink && (
        <DefaultText
          label={t('referral.referral-link-copied')}
          noMargin
          sx={{ fontSize: '0.9rem' }}
        />
      )}
    </Stack>
  )
}

export default memo(ReferFriends)
